module.exports = __webpack_public_path__ + "static/media/dibk-logo-mobile.3d8cd6bf.svg";